export default __webpack_public_path__ + "static/media/fullStack.0b7cc8cf.PNG";